import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function HeroCarousel({ sliders }) {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    if (sliders.length === 0) return;
    const interval = setInterval(
      () => setCurrentSlide((prev) => (prev + 1) % sliders.length),
      5000
    );
    return () => clearInterval(interval);
  }, [sliders.length]);

  if (sliders.length === 0) {
    return (
      <div className="h-screen flex items-center justify-center bg-gray-900 text-white">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-4">Welcome to UNGEGN ASED</h1>
          <p className="text-xl">Loading content...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="relative h-screen w-full overflow-hidden">
      {sliders.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? "opacity-100" : "opacity-0"
          }`}
        >
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />
          </div>

          <div className="relative h-full flex items-center justify-center text-center px-6 md:px-10 lg:px-16">
            <div className="max-w-4xl space-y-6 z-10">
              <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight tracking-tight">
                {slide.alt || "UNGEGN ASED"}
              </h1>
              <br></br>
              <p className="text-xl md:text-2xl text-white/90 font-light tracking-wide">
                Asia South-East Division
              </p>

              {slide.caption && (
                <p className="text-lg text-white/80 max-w-2xl mx-auto leading-relaxed">
                  {slide.caption}
                </p>
              )}

              <div className="mt-4">
                <Link
                  to="/aboutased"
                  className="inline-block px-4 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
                >
                  Learn More
                </Link>
              </div>
            </div>
          </div>
        </div>
      ))}

      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex space-x-3 z-10">
        {sliders.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrentSlide(i)}
            className={`transition-all rounded-full ${
              i === currentSlide
                ? "bg-white w-12 h-3"
                : "bg-white/50 w-3 h-3 hover:bg-white/70"
            }`}
          />
        ))}
      </div>
    </div>
  );
}
